import React, { useEffect, useState } from "react";

import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import { colors } from "@zapalacorp/tokens";

interface ILayoutWaitingConfig {
  isOpen: boolean;
  onClose?: () => void | Function;
  sx?: any;
  label?: string;
}

export default function LayoutWaiting(props: ILayoutWaitingConfig) {
  const { isOpen, onClose, sx, label } = props;
  const [open, setOpen] = useState(isOpen);

  useEffect(() => {
    setOpen(props?.isOpen);
  }, [props?.isOpen]);

  return (
    <React.Fragment>
      <Dialog
        fullScreen
        open={open}
        onClose={onClose}
        sx={{
          ...sx,
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            height: "100%",
            justifyContent: "center",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <CircularProgress
            sx={{
              width: "48px",
              height: "48px",
              color: colors.brandBlue500,
            }}
          />
          <div
            style={{
              color: colors.black,
              fontFamily: "Manrope",
              fontSize: "16px",
              fontWeight: 700,
              lineHeight: "24px",
              letterSpacing: "0.5px",
            }}
          >
            {label}
          </div>
        </div>
      </Dialog>
    </React.Fragment>
  );
}
